// Infos du site, centralisées ici (modifie juste ce fichier).
const siteInfo = {
  name: 'Boubou Studio',
  tagline: 'Le cinéma familial',
  version: '3.0.0',
  author: 'Thomas Boursac',
  since: 2009, // année de naissance du studio (pour le copyright)
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL || '',
};

export default siteInfo;
